var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isPopularArticle ? _c("table-widget") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.widgets, function ({ widgetType, articles }) {
        return [
          _vm.isTextWidget(widgetType)
            ? _c("text-widget", {
                attrs: { articles: articles, config: _vm.config },
              })
            : _vm.isCardWidget(widgetType)
            ? _c("card-widget", {
                attrs: { articles: articles, config: _vm.config },
              })
            : _vm.isSearchWidget(widgetType)
            ? _c("search-widget", {
                attrs: { articles: articles, config: _vm.config },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }